import React, { useEffect, useState } from "react";
import type { NextPage } from "next";
import Image from "next/image";
import Layout from "@/layout/layout";
import Astrobanner from "@/assets/images/sub-banner-astro.png";
import astrol from "@/assets/images/astrol.png";
import Link from "next/link";
import styles from "@/styles/astrologerList.module.scss";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";
import CurrencyInr from "@/components/common/currency-inr";
import { wrapper } from "@/store";
import { setPath, setTitle, setMeta } from "@/store/slices/helmet";
import { unbxdCusEngTrackEvent } from "@/lib/unbxd";

const AstrologerList: NextPage = () => {
  const [data, setData] = useState<any>([]);
  const loadList = async () => {
    try {
      const { data } = await httpClient.get(endpoints.astro.astrologerList());
      setData(data);
    } catch (error) {}
  };

  useEffect(() => {
    loadList();
  }, []);

  return (
    <Layout>
      <div className={styles.astro_banner}>
        <Image src={Astrobanner} alt="" />
        <div className={styles.astro_banner_text}>
          <div className="container h_100">
            <div className={styles.astro_banner_main}>
              <div className={styles.astro_banner_main_text}>
                <h1>Hassle&#8211;free Astro Consultation</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.astrologer_filter}>
        <div className="container">
          <div className="row justify-content-end">
            {/* <div className="col-md-4 col-sm-6">
              <select className="form-select" id="inputGroupSelect02">
                <option selected>Buy Price</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div> */}
          </div>
        </div>
      </div>
      <div className={styles.astrologer_main}>
        <div className="container">
          <div className="row">
            {!!data.length &&
              data.map((v: any) => (
                <>
                  <div className="col-md-4 col-sm-6">
                    <Link href={`/astro/book-appointment/${v.uuid}`} passHref>
                      <div
                        className={styles.astrologer_main_card}
                        onClick={() => {
                          if (window.smartech) {
                            unbxdCusEngTrackEvent("astro_book_clicked", {
                              name: v.name,
                              experience: v.experience,
                              fees: v.fee,
                              prid: v.uuid,
                              image: v.image,
                              amount: v.offer_fee ? v.offer_fee : v.fee,
                              url: `${process.env.NEXT_PUBLIC_APP_URL}/astro/book-appointment/${v.uuid}`,
                              discounted_price: v.offer_fee,
                            });
                          }
                        }}
                      >
                        <figure>
                          {v.image && (
                            <Image
                              src={v.image}
                              alt={v.name}
                              width={"354px"}
                              height={"236px"}
                            />
                          )}
                        </figure>
                        <div className="p-4">
                          <div className={styles.heading}>{v.name}</div>
                          <p className={styles.text_limit}>{v.info} </p>
                          <div className={styles.expri}>
                            <span className={styles.exp_sub}>Experience</span>
                            <span className={styles.exp_red}>
                              : {v.experience} Years
                            </span>
                          </div>
                          <div className={styles.expri}>
                            <div className="d-flex">
                              <span className={styles.exp_sub}>Fees :</span>
                              {v.offer_fee && v.offer_fee !== v.fee && (
                                <div className={styles.price2}>
                                  <span>
                                    <CurrencyInr value={v.fee} />
                                  </span>
                                </div>
                              )}{" "}
                              <span className={styles.exp_red}>
                                <CurrencyInr
                                  value={v.offer_fee ? v.offer_fee : v.fee}
                                />
                                /-
                              </span>
                              {/* <br /> */}
                            </div>
                          </div>
                          <div className={styles.more}>Select</div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </>
              ))}
          </div>
          {/* <button className={styles.button}>Load More</button> */}
        </div>
      </div>
    </Layout>
  );
};
export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ resolvedUrl }) => {
      store.dispatch(setPath(resolvedUrl));
      store.dispatch(setTitle("Find Expert Online Astrologers | Senco Gold"));
      store.dispatch(
        setMeta({
          title: "Find Expert Online Astrologers | Senco Gold",
          description:
            "Discover elegance at its finest with Senco Gold's best jewellery store near you. Explore exquisite designs crafted for every occasion.",
          keywords: "Find Expert Online Astrologers | Senco Gold",
        })
      );

      return {
        props: {},
      };
    }
);

export default AstrologerList;
